export enum PostStatus {
	PUBLISHED = "PUBLISHED",
	DRAFT = "DRAFT",
	ARCHIVED = "ARCHIVED",
	HIDDEN = "HIDDEN",
}
